import { useNotification } from "@kyvg/vue3-notification";
const { notify } = useNotification()

export default function setNotification(notification) {
    if (notification.heading && notification?.subHeading?.length) {
        notify({
            title: notification.heading,
            text: notification.subHeading,
            type: notification.type
        });
    }
}